export const getRandomRgb = function (alpha) {
    const num = Math.round(0xffffff * Math.random());
    const r = num >> 16;
    const g = num >> 8 & 255;
    const b = num & 255;
    return `rgb${alpha ? 'a': ''}(${r},${g},${b}${alpha ? `,${alpha}` : ''})`;
};

export const getColorsObject = function (alpha) {
	const num = Math.round(0xffffff * Math.random());
	const r = num >> 16;
	const g = num >> 8 & 255;
	const b = num & 255;
	return {
		mainColor: `rgb(${r},${g},${b})`,
		opacityColor: alpha ? `rgb${alpha ? 'a': ''}(${r},${g},${b}${alpha ? `,${alpha}` : ''})` : false
	};
};



// WEBPACK FOOTER //
// ./src/helpers/getRandomRgb.js